function Footer() {
  return <footer />;
}

export default Footer;
